import {
  CalculationDetailResponse,
  CalculationStatisticRouteResponse,
  CalculationStatisticStoreSourceResponse,
  CalculationStatisticStoreTargetResponse,
  SkuRedistributionResponse,
} from '@ydistri/api-sdk';
import { StatisticItem } from './StatisticsSummary';

export interface EditRedistributionDataIdentification {
  modalTitle?: string;
  routes?: CalculationStatisticRouteResponse[];
  sourceStores?: CalculationStatisticStoreSourceResponse[];
  targetStores?: CalculationStatisticStoreTargetResponse[];
  pickingPosition?: SkuRedistributionResponse;
  pickingPositions?: SkuRedistributionResponse[];
  useDepartments?: boolean;
  productId?: number;
}

export interface EditRedistributionData extends EditRedistributionDataIdentification {
  calculationId: number;
  modalHistory?: EditRedistributionDataIdentification[];
}

export const canEditCalculation = (calculation: CalculationDetailResponse | undefined): boolean => {
  return !!calculation?.isBackedUp;
};

export const parseChangelogData = <T>(data: string): T[] => {
  try {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- needed after json parsing
    const parsed = JSON.parse(data) as unknown[];
    if (!Array.isArray(parsed)) {
      // eslint-disable-next-line no-console -- info about wrong parse
      console.error('Expected array from parseChangelogData, got:', typeof parsed);
      return [];
    }

    return parsed
      .map(i => {
        if (typeof i !== 'string') {
          // eslint-disable-next-line no-console -- info about wrong parse
          console.error('Expected string array element, got:', typeof i);
          return null;
        }
        try {
          // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- needed after json parsing
          return JSON.parse(i) as T;
        } catch (error) {
          // eslint-disable-next-line no-console -- info about wrong parse
          console.error('Failed to parse array element:', error);
          return null;
        }
      })
      .filter((item): item is T => item !== null);
  } catch (error) {
    // eslint-disable-next-line no-console -- info about wrong parse
    console.error('Failed to parse changelog data:', error);
    return [];
  }
};

export const getTitleBasedOnModalData = (modalData: EditRedistributionData | undefined): string => {
  if (modalData?.modalTitle) return modalData.modalTitle;
  if (modalData?.pickingPosition) return 'Remove picking position';
  if (modalData?.pickingPositions) return 'Remove picking positions from redistribution';
  if (modalData?.sourceStores) return 'Remove source stores from redistribution';
  if (modalData?.targetStores) return 'Remove target stores from redistribution';
  if (modalData?.routes) return 'Remove routes from redistribution';
  if (modalData?.productId) return 'Remove product from redistribution';
  return 'Edit redistribution';
};

export interface ChangelogSectionProps {
  stringifiedData: string;
  onStatsComputed: (stats: StatisticItem[]) => void;
}
